<template>
<div @click="$sidebar.displaySidebar(false)">
	<div class="row" >
        <div class="col-xl-8 mb-5 mb-xl-0">
            <div class="card shadow">

				<div class="card-body">
					<div class="card-body-head">
						
						<div class="year-month">
							<h4>配信実績</h4>
							<ul>
									<li class="dropdown-content">
										<select id="year" class="year" @change="onYearChange">
											
											<option v-for="(year,key) in years" :value="year" :selected="selectedYear === year" :key="key">{{ year }}年</option>
										</select>
									</li>
									<li class="dropdown-content">
										<select id="month" class="month" @change="onMonthChange">
											<option v-for="(month,key) in months" :value="month" :selected="selectedMonth === month" :key="key">{{ month }}月</option>
											</select>
									</li>
									<li> 
									<button
										:disabled="loading"
										@click="getSentList"
										type="button" class="btn btn-primary btn-send">
										適用する
									</button>
								
									</li>
								</ul>
								
						</div>
						<div class="download-wrap">
							
							<button
									
										@click="csvExport"
										type="button" class="btn btn-download">
										CSVダウンロード
									</button>

							
						</div>
					</div>
					 

					<div class="loading"  v-show="loading">受信中...</div>

					<div class="el-table__body-wrapper table-responsive">
						<table class='table table-striped el-table__body' v-if="!loading">
							<thead>
								<tr class="el-table__row">
									<th scope="col">ID</th>
									<th scope="col">タイトル</th>
									<th scope="col">配信数</th>
									<th scope="col">有効配信数</th>
									<th scope="col">開封数</th>
									<th scope="col">開封率 (%)</th>
									<th scope="col">配信日時</th>	
									<th scope="col">&nbsp;</th>		      
								</tr>
							</thead>
							<tbody>

							<tr v-for="(notification, key) in notificationList" :key="key" class="el-table__row">

									<td class="el-table_1_column_1"> {{ notification.id }} </td>
									<td  class="el-table_1_column_2"><p>{{ notification.title }}</p></td>
									<td  class="el-table_1_column_3"> {{ notification.sent_cnt }} </td>
									<td  class="el-table_1_column_4"> {{ notification.sent_success_cnt }}  </td>
									<td  class="el-table_1_column_4"> {{ notification.read_cnt }} </td>
									<td  class="el-table_1_column_4"> {{ getPercentage(notification) }} </td>
									<td  class="el-table_1_column_4"> {{ formatToLocal(notification.sent_date) }}  </td>
									<td class="el-table_1_column_5"><a :href="'/notifications/'+ siteId + '/detail'+'/' + notification.id" >詳細</a></td>
									
								</tr>
							
							</tbody>
						</table>
					</div>
				</div>

				
			</div>
        </div>
    </div> 
   <!--
	<div class="row" @click="$sidebar.displaySidebar(false)">
        <div class="col-xl-8 mb-5 mb-xl-0">
            <div class="card shadow">
				
				<div class="card-body">
					<h4>配信実績ダウンロード</h4>

					<div class="form-group">
						<label for="datepicker">配信日時</label>
							<div class="form-row">
								<datepicker :value="nowDate" name="uniquename"></datepicker>
							
							</div>
					</div>
				</div>
            </div>
        </div>
	</div>
	-->
</div>      
</template>


<script>

import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

export default {
    components: { 
		Datepicker, 
    	moment
	},
    
	data() {
		return {
			siteId:null,
			nowDate:new Date(),
			yearMonth:"",
			selectedMonth:null,
			selectedYear:null,
			// Our data object that holds the Laravel paginator data
			notificationList: {},
			loading:false,
			startDate:"",
			menuId:"menuSentList",
			endDate:"",
			disabledDates: {
				to: new Date(Date.now() - 8640000) 
			},
			ja:ja
		}
	},
	
	filters: {
    moment
  },

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		this.getResults();
		
	},
	computed : {
		years () {
			const year = new Date().getFullYear()
			return Array.from({length: year - 2018}, (value, index) => 2019 + index)
		},
		
		months () {
			return Array.from({length: 12}, (value, index) => 1 + index)
		}
	},
	methods: {
		customFormatter(date) {
      		return moment(date).format('YYYY年MM月DD日');
    	},
	
	     formatToLocal(date) {
	        return moment.utc(date).local().format('YYYY年MM月DD日 HH:mm:ss');
           // return moment(date).isSame(moment().clone().startOf('day'), 'd');
        },
		// Our method to GET results from a Laravel endpoint
		/*getResults(page = 1) {
			if(this.lastpage != null && this.lastpage < page) return;
			axios.get('/sentlist?page=' + page)
				.then(response => {
					this.notificationList = response.data;
					this.lastpage = response.data.last_page
				});
		},*/
		getPercentage(notification) {
			return ((notification.read_cnt/notification.sent_cnt) * 100).toFixed(2);
		},

 		initializeSelection () {
		    this.selectedMonth = new Date().getMonth() + 1;
			this.selectedYear = new Date().getFullYear();
	    },
		onMonthChange(event) {
	      this.selectedMonth = parseInt(event.target.value);
	    },
	    onYearChange(event) {
	      this.selectedYear = parseInt(event.target.value);
		},
		// Our method to GET results from a Laravel endpoint
		getResults() {
			if(!this.selectedYear || !this.selectedMonth) {
				this.initializeSelection();
			}
			this.siteId = window.PushL.site_id;
			
			axios.get('/history/'+ this.siteId+'/sentlist/'+ this.selectedYear + '/' + this.selectedMonth)
				.then(response => {
					this.notificationList = response.data;
					this.total = response.data.total;
					this.loading = false;
					
				});
		},

		getSentList () {
		this.loading = true;
	      this.getResults();
		},
		nl2br(text) {
			return text.replace(/\n/g, "<br>")
		},

		csvExport() {
	  let csvContent = "data:text/csv;charset=utf-8,";
	  const arrData = this.notificationList;
	  if(!arrData.length) return;
      csvContent += [
        Object.keys(arrData[0]).join(";"),
        ...arrData.map(item => Object.values(item).join(";"))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
	  link.setAttribute("href", data);
	  const fileName = 'sentlist_' +this.selectedYear + this.selectedMonth
      link.setAttribute("download", fileName);
      link.click();
    }

	}

}
</script>

<style scoped>
    ul {
    float:left;
    padding:0;
    }
    li {
	float: left;
	margin: 5px 10px;
    }

	.year-month {
		float: left ;
		display: flex;
	}
    .year-month span {
	    display: inline-block;
	    float: left;
	    padding: 10px 30px;
    }
	
	select.year {
		width: 80px;
	}
	select.month {
		width: 60px;
	}
    select {
	height:36px;
	font-size: 13px;
	border-radius:4px;
	margin-top:4px;
	padding: 0 7px;
	background-position-x: 100%;
	background-position-y:7px;
	margin-right:0;
    }
    .loading {
        padding-top: 150px;
         padding-bottom: 150px;
	    font-size: 1.3em;
    }
    thead {
        background-color: #f8f9fe;
    	color: #181818;
    }
   
    
</style>